<template>
    <div class="emoji-code-container">
        <single-emoji-code
                v-bind:code="singleCode"
                v-bind:key="i"
                v-bind:type="type"
                v-for="(singleCode, i) in codeParts"
        ></single-emoji-code>
    </div>
</template>

<script>
    import SingleEmojiCode from './single-emoji-code'
    import {$eBus} from '@/event-bus'
    import GameClientEvent from "../../enum/GameClientEvent";

    export default {
        name: 'emoji-code',
        components: {
            SingleEmojiCode
        },
        props: {
            type: {
                type: String,
                required: false,
                default: 'default'
            }
        },
        data() {
            return {
                codeParts: []
            }
        },
        mounted() {
            $eBus.$off(GameClientEvent.CustomRoomIdChanged, this.onCustomRoomIdChanged);
            $eBus.$on(GameClientEvent.CustomRoomIdChanged, this.onCustomRoomIdChanged);

            this.recalculateCodeParts();
        },
        beforeDestroy() {
            $eBus.$off(GameClientEvent.CustomRoomIdChanged, this.onCustomRoomIdChanged);
        },
        methods: {
            onCustomRoomIdChanged(customId) {
                this.recalculateCodeParts(customId);
            },
            recalculateCodeParts(customId = null) {
                try {
                    if (!customId) {
                        customId = this.$gameClient ? this.$gameClient.customId : null;
                    } else {
                        customId = customId + '';
                    }

                    let codeParts = [];

                    if (customId) {
                        for (let i = 0, len = customId.length; i < len; i++) {
                            codeParts.push(customId[i]);
                        }
                    }

                    this.codeParts = codeParts;
                } catch (error) {
                    this.codeParts = [];
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .emoji-code-container {
        text-align: center;

        white-space: nowrap;
    }
</style>